import styled from 'styled-components';
import { PlayWrapper } from './Play.style';
import { IconWrapper, SummaryPlayEvent } from './play/SummaryPlayEvents.style';
import { PlayActionDescription } from './play/playEvents/PlayAction.style';

export const SummaryPlayWrapper = styled(PlayWrapper)`
  div[data-game-type="offensive_substitution"] + div[data-game-type="offensive_substitution"] {
      ${IconWrapper} {
        display: none;
      }
      ${SummaryPlayEvent} {
        display: none;
      }
      ${PlayActionDescription} {
        margin-top: -16px;
      }
  }

  div[data-game-type="defensive_substitution"] + div[data-game-type="defensive_substitution"] {
    ${IconWrapper} {
      display: none;
    }
    ${SummaryPlayEvent} {
      display: none;
    }
    ${PlayActionDescription} {
      margin-top: -16px;
    }
  }

  >div {
    margin-bottom: 24px;
  }
`;
